var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '../../../client/api/apiClient';
function get() {
    return apiClient.get('/api/woo/products');
}
function getAdapter(serverProducts) {
    const products = serverProducts.map((product) => ({
        thumbnails: product.images[0].src,
        url: product.permalink,
    }));
    return { products };
}
function getEBusinessCards() {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield get();
        if (!res.ok)
            return;
        const { products } = res.data;
        return getAdapter(products).products;
    });
}
export default {
    getEBusinessCards,
};
